// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"365":"6da9226f","734":"73e0acee"}[chunkId] + ".chunk.css";
};